import { motion, useAnimation } from "framer-motion";
import React, { useEffect, useState } from "react";
import { BiCaretDownCircle, BiNotification } from "react-icons/bi";
import { IoNotificationsCircleOutline } from "react-icons/io5";
import { useInView } from "react-intersection-observer";
import { SocialIcon } from "react-social-icons";
import { box, container, leftContent } from "../data/anim";
import bg from "../assets/bg.jpg";
import { statusCount } from "../actions/messageActions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
const Introduction = ({ toggle, setToggle }) => {
  const { state } = useLocation();
  const [show, setShow] = useState(true);
  const [counts, setCounts] = useState({});
  const messageDetail = useSelector((state) => state.messageDetail);
  const dispatch = useDispatch();
  const { ref, inView } = useInView();
  const animation = useAnimation();

  useEffect(() => {
    (async function statusCounts() {
      const data = await statusCount();
      setCounts(data);
    })();
  }, []);

  useEffect(() => {
    if (inView) {
      animation.start({
        opacity: 1,
        x: 0,
        transition: {
          duration: 3.5,
          type: "spring",
          bounce: 0.2,
        },
      });
    } else {
      animation.start({
        opacity: 0,
        x: "-100vw",
      });
    }
  }, [inView, animation]);
  return (
    <>
      <div ref={ref} className="introduction">
        <div className="body">
          <div className="left">
            <motion.div
              variants={leftContent}
              initial="hidden"
              animate="visible"
              className="text-intro"
            >
              <h2>
                Hello! I'm Jade.
                <br />I am an
                <br />
                <span>aspiring</span>
                web developer.
              </h2>
            </motion.div>
            <motion.div
              variants={container}
              initial="hidden"
              animate={show ? "visible" : "hidden"}
              className="social-icons"
            >
              <a href={`/admin`}>
                <motion.div variants={box} className="icons">
                  <IoNotificationsCircleOutline
                    className="notification"
                    style={{ color: "orange", fontSize: "0.5rem" }}
                  />
                  {counts?.Unread >= 0 && (
                    <span className="notify-count-container">
                      {counts?.Unread}
                    </span>
                  )}
                </motion.div>
              </a>
              <motion.div variants={box} className="icons">
                <SocialIcon
                  url="https://www.facebook.com/Demon.rimuruTempest/"
                  target="_blank"
                />
              </motion.div>
              <motion.div variants={box} className="icons">
                <SocialIcon
                  url="https://www.linkedin.com/in/jade-darunday-94a474153/"
                  target="_blank"
                />
              </motion.div>
              <motion.div variants={box} className="icons">
                <SocialIcon
                  url="https://github.com/jade-kenneth"
                  target="_blank"
                />
              </motion.div>
              <motion.span
                onClick={() => setShow(!show)}
                variants={box}
                animate={show ? "rotate90deg" : "rotate180deg"}
                className="caret"
              >
                <BiCaretDownCircle className="icon" />
              </motion.span>
            </motion.div>
          </div>
          <div className="right">
            <div
              className="burger-container"
              onClick={() => setToggle(!toggle)}
            >
              <span className={toggle ? "bar1 change" : "bar1"}></span>
              <span className={toggle ? "bar2 change" : "bar2"}></span>
              <span className={toggle ? "bar3 change" : "bar3"}></span>
            </div>
            <motion.img animate={animation} src={bg} alt="" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Introduction;
